import { Flex } from 'foundations-components/components/Flex';
import { AcademyAssistantShell } from 'academy-ai-assistant-lib/components/AcademyAssistantShell';
import { useAcademyAssistant } from 'academy-ai-assistant-lib/hooks/useAcademyAssistant';
import { HasGate } from 'academy-common-lib/features/accounts/components/HasGate';

// Recess the page backdrop while the assistant is open so the panel and the
// reflowed page read as one surface (matches academy-home-ui).
import { jsx as _jsx } from "react/jsx-runtime";
const AssistantHost = ({
  children
}) => {
  const {
    isOpen
  } = useAcademyAssistant();
  return /*#__PURE__*/_jsx(Flex, {
    backgroundColor: isOpen ? 'fill-surface-recessed' : undefined,
    blockSize: "100%",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(AcademyAssistantShell, {
      overlayAnchor: "viewport",
      children: children
    })
  });
};

/**
 * Wraps the page in the Academy Assistant host only for accounts with the
 * `Academy:AiAssistant:AskAcademyAssistant` gate; otherwise renders the page
 * unchanged. The shell stays closed until opened via `useAcademyAssistant()`.
 */
export const GatedAcademyAssistantShell = ({
  children
}) => /*#__PURE__*/_jsx(HasGate, {
  fallback: children,
  gate: "Academy:AiAssistant:AskAcademyAssistant",
  children: /*#__PURE__*/_jsx(AssistantHost, {
    children: children
  })
});